module.exports = __webpack_public_path__ + "static/media/star-icon-v2.85ae2798.svg";